import styled from "styled-components/macro";

export default styled.p(({ theme }) => ({
  color: theme.color.brandPrimary.dark,
  margin: "16px 0px",
}));
